import React, { useMemo } from "react"
import styled from "styled-components"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { containerMaxWidth, MEDIA_MIN_LARGE } from "../../constants"

const Container = styled.div`
  ${(p) => !p.desktopFullWidth && `max-width: ${containerMaxWidth};`}
  margin: 0 auto;
  width: 100%;
  padding: 0 ${(p) => (p.mobileFullWidth ? "0" : "2.5rem")};
  display: flex;
  justify-content: center;

  ${MEDIA_MIN_LARGE} {
    padding: ${(p) => (p.columns ? "1rem" : "0")};
    width: ${(p) =>
      p.columns ? `calc(100% / ${p.columns} - ${p.columns * 0.8}rem)` : "100%"};
    ${(p) => p.maxWidth && `max-width: ${p.maxWidth / 10}rem;`}
  }
`

const StyledImageMobile = styled(GatsbyImage)`
  width: 100%;
  max-width: 100%;

  ${MEDIA_MIN_LARGE} {
    display: none !important;
  }
`

const StyledImageDesktop = styled(GatsbyImage)`
  display: none !important;
  width: 100%;

  ${MEDIA_MIN_LARGE} {
    display: block !important;
  }
`

const Image = ({ data, columns }) => {
  const {
    imageFile,
    mobileImageFile,
    imageMaxWidth,
    mobileFullWidth,
    desktopFullWidth
  } = data

  const mobileImage = useMemo(
    () => getImage(mobileImageFile?.asset || imageFile.asset),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
  const desktopImage = useMemo(
    () => getImage(imageFile.asset),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <Container
      columns={columns}
      maxWidth={imageMaxWidth}
      mobileFullWidth={mobileFullWidth}
      desktopFullWidth={desktopFullWidth}
    >
      <StyledImageMobile image={mobileImage} />
      <StyledImageDesktop image={desktopImage} />
    </Container>
  )
}

export default Image
